<template>
    <input type="text" style="width:100px;margin-right: 3px;"  class="datepicker"/>
</template>
<script>
  export default{
    props:['datepicker']
    ,data:{
        date : null
    }
    ,mounted:function(){
        let vm = this;
        console.log(vm);
        console.log(vm.datepicker);
         console.log(vm.$props.datepicker);
        $(this.$el).datepicker({
          monthNames: ['년 1월','년 2월','년 3월','년 4월','년 5월','년 6월','년 7월','년 8월','년 9월','년 10월','년 11월','년 12월'],
          monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
          dayNames: ['일', '월', '화', '수', '목', '금', '토'],
          dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
	        dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
	        changeMonth: true,
	        changeYear: true,
          showMonthAfterYear:true,
          dateFormat: 'yy-mm-dd',
          buttonImage: "/design/common/img/btn_cld.gif",
          buttonImageOnly: true,
          showButtonPanel: false,
          showOn: "both"
          ,onSelect: function(d){ console.log(d); vm.date = d; vm.$emit('update-date',d)}
      });
       
       $('.datepicker').val(this.datepicker)
    },
    beforeDestroy: function(){
      let vm = this;
       if(vm.$props.datepicker == null && vm.$props.datepicker == undefined){
          $(this.$el).datepicker('hide').datepicker('destroy');
       }
    }
  }
</script>